export default {"src":"/_next/static/media/promotion-fill.11303e18.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};